/**
 * Copyright (c) 2021
 *
 * @summary Idlel State processing module. This module check for the idle state and create alert for user convenience.
 * so that user can logout or 
 * @author Amol Botare <amol.b@bahwancybertek.com>
 *
 * Created at     : 2021-03-18  
 * Last modified  : 2021-03-18
 */

import React from 'react'
import { Modal, Button } from 'react-bootstrap';
import IdleTimer from 'react-idle-timer';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Config from './config/appConstants';
import { createRequest } from './services/api/helper';
// import { IdleTimeOutModal } from './modal/IdleModal'
// import { CountdownCircleTimer } from "react-countdown-circle-timer";
import Images from './config/Images'
import translateLabel from './components/shared/translation';

class IdleHandler extends React.Component {

    constructor(props) {
        super(props)

        this.state = {
            timeout: 1000 * 60 * Config.IDLE_TIMEOUT, //1000 * 60 * 0.5, //12000 * 5 * 1   2 min for Timeout 1 min for alert pop      //6000 * 5 * 1    1 min for Timeout 30 sec for alert pop 
            showModal: false,
            userLoggedIn: false,
            isTimedOut: false,
            isSession: false,
            timoutWarning: 1000 * 60 * 0.5, //840000, // Display warning in 14 Mins.
            timoutNow: 60000, //60000 // Warning has been shown, give the user 1 minute to interact
            remainingTime:60
        }
        this.Timer = ''
        this.idleTimer = null;
        this.onAction = this._onAction.bind(this);
        // this.onActive = this._onActive.bind(this);
        this.onIdle = this._onIdle.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleLogout = this.handleLogout.bind(this);

        this.warningTimer = "";
        this.timeoutTimer = "";

        this.timerProps = {
            isPlaying: true,
            size: 100,
            strokeWidth: 6
        };

        this.stratTime = ""; // use UNIX timestamp in seconds
        this.endTime = ""; // use UNIX timestamp in seconds
        this.remainingTime = "";
        this.minuteSeconds = 60;
    }

    getTimeSeconds = (time) => (this.minuteSeconds - time) | 0;
    renderTime = (dimension, time) => {
        return (
            <div className="time-wrapper" style={{ textAlign: "center" }}>
                <div className="time">{time}</div>
                <div>{dimension}</div>
            </div>
        );
    };
    /**
     * This is on action event for mouse and key events
     * @param {event} e 
     */
    _onAction(e) {
        // console.log('onAction', this.state.isTimedOut)
        if (!this.state.isTimedOut) {
            this.setState({ isTimedOut: false })
            this.idleTimer && this.idleTimer.reset();
            // this.respList()
        }
    }

    /**
     * List Applicable API call.
     * @param {object} service 
     * @return {void}
     */
    respList = (service) => {

        let params = 'ServiceDomain=' + Config.ESERVICE_CODE['land'];
        // APIURL = Config.LAND_APPLICABLE_SERVICES + '?ServiceDomain=' + Config.ESERVICE_CODE['land'];
        createRequest('get', Config.LAND_APPLICABLE_SERVICES, 1, {}, params)
            .then((response) => {

                // console.log('idle response', response);

            }, (error) => {
                console.log("axios:land_service_error  == " + error);
            });
    }

    getRemainingTime=()=>{
        let remainingTime = 60
        let timer = setInterval(()=>{
            console.log("remianin",remainingTime)
            remainingTime = remainingTime - 1
            this.setState({remainingTime})
            if(remainingTime === 0 ){
                this.setState({remainingTime:0})
                clearInterval(timer);
                window.location.href = "/"
            }
        },1000)
        return timer;
    }

    /**
     * Idle Event Listener
     * @param {event} e 
     */
    _onIdle(e) {
        const isTimedOut = this.state.isTimedOut
        if (isTimedOut) {
            this.setState({ showModal: false })
            this.remainingTime = "";
            // this.props.history.push('/')
            window.location.href = "/"
        } else {
            this.setState({ showModal: true })
            this.setState({ isTimedOut: true });
            this.stratTime = Date.now() / 1000; // use UNIX timestamp in seconds
            this.endTime = this.stratTime + 243248; // use UNIX timestamp in seconds
            this.remainingTime = this.endTime - this.stratTime;
            this.minuteSeconds = 60;
            this.Timer = this.getRemainingTime()
        }

    }

    startTimer(totalElapsedTime) {
        if (totalElapsedTime === this.minuteSeconds) {
            this.setState({ showModal: false })
            this.remainingTime = "";
            window.location.href = "/"
        } else {
            return (
                [
                    this.remainingTime - totalElapsedTime > 0
                ]
            )
        }
    }

    /**
     * Close Modal handler
     * @return {void}
     */
    handleClose() {
        clearInterval(this.Timer)
        this.respList()
        this.setState({ remainingTime: 60,isTimedOut:false, showModal: false })
    }


    /**
     * Logout handler
     * 
     */
    handleLogout() {
        clearInterval(this.Timer)
        this.setState({ remainingTime: 60,showModal: false })
        // this.props.history.push('/')
        window.location.href = "/"
    }


    componentDidMount() {
        setImmediate(() => {
            this.setState({
                isSession: true
            })
        }, 1000)
    }


    /**
     * Render Lifecycle
     * @return {node}
     */
    render() {

        const { showModal, timeout } = this.state

        const { history, pki_details } = this.props

        // console.log('this.props.children', this.props.children)

        // const isEserviceActive = history && history.location.pathname.match("e-service")

        // if (pki_details && pki_details.SessionID && history.location && history.location.pathname !== '/login') {
        //     return <><IdleTimer
        //         ref={ref => { this.idleTimer = ref }}
        //         element={document}
        //         onActive={this.onActive}
        //         onIdle={this.onIdle}
        //         onAction={this.onAction}
        //         debounce={250}
        //         timeout={timeout}
        //         handleClose={this.handleClose}
        //         handleLogout={this.handleLogout}
        //     />
        //         <div className="">
        //             {this.props.children}
        //             <Modal show={showModal} onHide={this.handleClose}>
        //                 <Modal.Header closeButton>
        //                     <Modal.Title>You Have Been Idle!</Modal.Title>
        //                 </Modal.Header>
        //                 <Modal.Body>Your session is about to expire. You want to stay?</Modal.Body>
        //                 <Modal.Footer>
        //                     <Button variant="danger" onClick={this.handleLogout}>
        //                         Logout
        //         </Button>
        //                     <Button variant="primary" onClick={this.handleClose}>
        //                         Stay
        //         </Button>
        //                 </Modal.Footer>
        //             </Modal>
        //         </div>
        //     </>
        // } else {
        //     return <>{this.props.children}</>
        // }


        return (
            <div>
                {this.props.children}
                {
                    pki_details && pki_details.SessionID && history.location && history.location.pathname !== '/login' ?
                        <>
                            <IdleTimer
                                ref={ref => { this.idleTimer = ref }}
                                element={document}
                                onActive={this.onActive}
                                onIdle={this.onIdle}
                                onAction={this.onAction}
                                debounce={250}
                                timeout={timeout}
                                handleClose={this.handleClose}
                                handleLogout={this.handleLogout}
                            />
                            <Modal show={showModal} onHide={this.handleClose}>
                                <Modal.Header>
                                <Modal.Title style={{ color:'white'}} className={`${this.props.lang === Config.LANG.AR ? 'text-right' : 'text-left'}`}>{translateLabel('IDLE_TITLE')}</Modal.Title>
                                    <button type="button" className={`btn-close btn-close-white m-0 ${this.props.lang === Config.LANG.AR ? 'text-left' : 'text-right'}`} data-bs-dismiss="modal" aria-label="Close" onClick={this.handleClose}></button>
                                </Modal.Header>
                                <Modal.Body>
                                <div className={`${this.props.lang === Config.LANG.AR ? 'text-right' : 'text-left'}`}>
                                            <p>{translateLabel('IDLE_MSG_LINE_1')}</p>
                                            <p>{translateLabel('IDLE_MSG_LINE_2')}</p>
                                        </div>
                                    <div style={{ display: "inline-flex", paddingTop: "10px", alignItems:'center', justifyContent:'space-betweens' }}>
                                        {/* <div style={{paddingLeft: "160px", textAlign: "center"}}> */}
                                        <img alt="payment" style={{ width: "63%", display: "inline-block", paddingLeft: "80px", paddingRight: "72px" }} className={this.props.lang === Config.LANG.AR ? "img paymentResponseImg img-transform" : "img paymentResponseImg"} src={Images.SessionExpired} />
                                        {/* <CountdownCircleTimer
                                            {...this.timerProps}
                                            colors={[["#056ca2"]]}
                                            style={{ paddingLeft: "55px" }}
                                            duration={this.minuteSeconds}
                                            initialRemainingTime={0}
                                            onComplete={(totalElapsedTime) => this.startTimer(totalElapsedTime)}
                                        >
                                            {({ elapsedTime }) =>
                                                this.renderTime("seconds", this.getTimeSeconds(elapsedTime))
                                            }
                                        </CountdownCircleTimer> */}
                                            <div class="circular">
                                                <div class="inner"></div>
                                                <div class="number">{this.state.remainingTime} {translateLabel("SECONDS")}</div>
                                                <div class="circle">
                                                <div class="bar left">
                                                    <div class="progress"></div>
                                                </div>
                                                <div class="bar right">
                                                    <div class="progress"></div>
                                                </div>
                                                </div>
                                            </div>
                                    </div>
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button variant="danger" onClick={this.handleLogout}>
                                    {translateLabel("logout")}
                 </Button>
                                    <Button variant="primary" onClick={this.handleClose}>
                                    {translateLabel("Stay")}
                 </Button>
                                </Modal.Footer>
                            </Modal>
                        </>
                        : null
                }
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    pki_details: state.pki_details,
    lang : state.lang.lang
});


export default withRouter(connect(mapStateToProps)(IdleHandler))



 // const IdleHandle = withRouter(({ showModal, idleTimer, timeout, onActive, onAction, onIdle, children, handleClose, handleLogout, history, location }) => {

 //     // const history = useHistory()

 //     console.log('history && history.location.pathname.match("e-service")', location, history)

 //     if (history && history.location.pathname.match("e-service")) {
 //         return (
 //             <>

 //             </>
 //         )
 //     } else {
 //         return <>{children}</>
 //     }
 // })